import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@mui/material'

import { useTranslation } from 'shared/hooks/useSafeTranslation'
import useStyle from 'shared/hooks/useStyle'

import styles from './CartaScanSummary.style'

const propTypes = {
    value: PropTypes.string,
    isAnswered: PropTypes.bool,
    onRetry: PropTypes.func,
}

const CartaScanSummary = ({
    isAnswered = false,
    value = '',
    onRetry,
}) => {
    const { t } = useTranslation()
    const classes = useStyle(styles)

    return (
        <div css={classes.root}>
            { !isAnswered && t('NO_SCAN_PERFORMED') }
            { isAnswered && `${t('SELECTED_CARTA_LOGGER')} ${value}` }
            { onRetry && (
                <div css={classes.actions}>
                    <Button
                        data-testid="retry-button"
                        css={classes.button}
                        onClick={onRetry}
                    >
                        {t('RETRY')}
                    </Button>
                </div>
            )}
        </div>
    )
}

CartaScanSummary.propTypes = propTypes

export default CartaScanSummary
